var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { Modal } from "../../../../../../Components/UI";
import { Link } from 'react-router';
import { Translate } from "../../../../../../../I18N";
import { AddExtractorSteps } from "./steps";
import { useCreateExtractorContext } from "./CreateExtractorContext";
import { Steppers } from "./Steppers";

const TEMPLATE_CRITERIA_LINK =
'https://uwazi.readthedocs.io/en/latest/admin-docs/paragraph-extraction.html';

const Dialog = () => {
  const { step, setShowModal, targetTemplateOptions } = useCreateExtractorContext();
  const CurrentStepBody = AddExtractorSteps[step].Body;
  const CurrentStepFooter = AddExtractorSteps[step].Footer;

  return (/*#__PURE__*/
    _jsx(Modal, { size: "xxl" }, void 0, /*#__PURE__*/
    _jsx(Modal.Header, {}, void 0, /*#__PURE__*/
    _jsx("h1", { className: "text-lg font-semibold text-gray-900" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, AddExtractorSteps[step].title)
    ), /*#__PURE__*/
    _jsx(Modal.CloseButton, { onClick: () => setShowModal(false) })
    ), /*#__PURE__*/
    _jsx(Modal.Body, { className: "pt-0" }, void 0, /*#__PURE__*/
    _jsx(CurrentStepBody, {}), /*#__PURE__*/
    _jsx("div", { className: "flex flex-col" }, void 0, /*#__PURE__*/
    _jsx(Steppers, {
      step: step,
      steps: Object.keys(AddExtractorSteps).length,
      isDisabled: targetTemplateOptions.length === 0 }
    ),
    step !== 3 && /*#__PURE__*/
    _jsx("span", {
      className: `mt-5 text-gray-500 font-light text-sm ${targetTemplateOptions.length === 0 ? 'invisible' : ''}` }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Templates meeting"), ' ', /*#__PURE__*/
    _jsx(Link, { to: TEMPLATE_CRITERIA_LINK, target: "_blank", className: "underline" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "required criteria")
    )
    )

    )
    ), /*#__PURE__*/
    _jsx(Modal.Footer, {}, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex flex-col w-full" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex gap-2" }, void 0, /*#__PURE__*/
    _jsx(CurrentStepFooter, {})
    )
    )
    )
    ));

};

export { Dialog };